import type { PortableTextComponentProps } from '@portabletext/react'
import type { PortableTextBlock } from '@portabletext/types'
import type { FC } from 'react'

export const Block: FC<
  PortableTextComponentProps<PortableTextBlock> & { className: string }
> = ({ children, value, isInline, renderNode, ...props }) => {
  const styleIs = (style: string) =>
    style === (value.style as unknown as string)

  return styleIs('h1') ? (
    <h1 {...props}>{children}</h1>
  ) : styleIs('h2') ? (
    <h2 {...props}>{children}</h2>
  ) : styleIs('h3') ? (
    <h3 {...props}>{children}</h3>
  ) : styleIs('h4') ? (
    <h4 {...props}>{children}</h4>
  ) : styleIs('h5') ? (
    <h5 {...props}>{children}</h5>
  ) : styleIs('h6') ? (
    <h6 {...props}>{children}</h6>
  ) : styleIs('blockquote') ? (
    <blockquote {...props}>{children}</blockquote>
  ) : styleIs('normal') ? (
    <p {...props}>{children}</p>
  ) : styleIs('normalFullWidth') ? (
    <p {...props}>{children}</p>
  ) : null
}
